import {Component, OnInit} from '@angular/core';
import {TdoClientConfigurationModel} from '../../../../models/clients/tdo-client-configuration.model';
import {ClientLocationDataModel} from '../../../../models/clients/client-location-data.model';
import {TdoDropdownChange} from '../../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import {OperatoriesService} from '../../operatories/operatories.service';
import {PresentationFoldersConfigurationService} from './presentation-folders-configuration.service';
import {DocumentFolderDataModel} from '../../../../models/document/document-folder-data.model';
import {Globals} from '../../../../globals';
import {FileManagerService} from '../../../file-manager/file-manager.service';
import {PresentationFoldersConfigurationModel} from '../../../../models/configuration/presentation-folders-configuration.model';
import {DeviceConfigurationModel} from '../../../../models/configuration/device-configuration.model';
import {ProcedureSelectionDialogModel} from '../../../../dialog/procedure-selection-dialog/models/procedure-selection-dialog.model';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {TdoOrganizerComponent} from '../../../../main-interface/controls/tdo-organizer/tdo-organizer.component';
import {FolderSelectionDialogComponent} from '../../../../dialog/folder-selection-dialog/folder-selection-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {IoTreeNodeModel} from '../../../imaging/models/io-tree-node.model';
import {ITdoTreeItem} from '../../../../tdo-controls/common/tdo-tree/models/i-tdo-tree-item';
import {IoTreeNodeTypeModel} from '../../../imaging/models/io-tree-node-type.model';

@Component({
  selector: 'app-presentation-folders-configuration',
  templateUrl: './presentation-folders-configuration.component.html',
  styleUrls: ['./presentation-folders-configuration.component.scss']
})
export class PresentationFoldersConfigurationComponent implements OnInit{
  clientList: TdoClientConfigurationModel[];
  locationList: ClientLocationDataModel[];
  folderList: PresentationFoldersConfigurationModel[];
  // libraryFoldersList: DocumentFolderDataModel[];
  // lectureFoldersList: DocumentFolderDataModel[];
  selectedClient: TdoClientConfigurationModel;
  selectedLocation: ClientLocationDataModel;
  selectedFolder: PresentationFoldersConfigurationModel;
  libraryFolders: DocumentFolderDataModel[];
  lectureFolders: DocumentFolderDataModel[];

  editedFolders: PresentationFoldersConfigurationModel[] = [];
  isLoading = true;
  FolderTreeData: IoTreeNodeModel[] = [];
  selectedFolderTreeNode: IoTreeNodeModel;

  constructor(private presentFolderService: PresentationFoldersConfigurationService,
              private globals: Globals,
              private dialog: MatDialog,
              private presentationService: PresentationFoldersConfigurationService,
              private fileService: FileManagerService,
              private snackbar: MatSnackBar,
              private opsService: OperatoriesService) { }

  ngOnInit(): void {
    this.opsService.getClients().subscribe(data => {
      this.clientList = data;
      const currentClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
      if (currentClient) {
        this.selectedClient = currentClient;
      } else {
        this.selectedClient = this.clientList[0];
      }

      this.opsService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
        this.locationList = ldata;

        if (this.locationList.length > 0) {
          const currentLoc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
          if (currentLoc) {
            this.selectedLocation = currentLoc;
          } else {
            this.selectedLocation = this.locationList[0];
          }
          const evt = new TdoDropdownChange();
          evt.value = this.selectedLocation;
          evt.isUserInput = true;
          this.onChangeLoc(evt);
        }

        this.isLoading = false;
      });

    }, err => {
      console.log(err);
      this.isLoading = false;
    });
    this.getLibraryFolders();
  }

  private async getLibraryFolders() {
    this.fileService.getLibraryDocumentFolders().subscribe((res) => {
      this.libraryFolders = res.LibraryFolders;
      this.lectureFolders = res.LectureFolders;
      //this.initLectureTree(res.LectureFolders);
    });
  }

  private initFolderTree(folders: PresentationFoldersConfigurationModel[]): void {
    let isFound = false;
    let rootNode: IoTreeNodeModel;
    const rootFolders = folders.filter(p => p.ParentFolderPresentationID == null);
    const nonRootFolders = folders.filter(p => p.ParentFolderPresentationID !== null);
    for (const root of rootFolders) {
      rootNode = new IoTreeNodeModel();
      const rootNodeData = root;
      rootNode.id = rootNodeData.FolderPresentationID;
      // rootNode.documents.push(rootNodeData.DocumnetFolderId);
      // rootNode.id = rootNodeData.DocumnetFolderId;
      rootNode.name = rootNodeData.DisplayName;
      rootNode.type = IoTreeNodeTypeModel.Default;
      rootNode.isExpanded = true;
      this.FolderTreeData.push(rootNode);

      for (const folder of nonRootFolders) {
        const childNode = new IoTreeNodeModel();
        childNode.id = folder.FolderPresentationID;
        childNode.name = folder.DisplayName;
        childNode.type = IoTreeNodeTypeModel.Default;
        childNode.isExpanded = true;
        if (folder.ParentFolderPresentationID === rootNode.id) {
          rootNode.children.push(childNode);
          isFound = true;
        }
        else {
            const parent = this.sortFoldersIntoFolders(rootNode, folder);
            if (parent) {
              parent.children.push(childNode);
            }
        }
      }
    }
  }

  sortFoldersIntoFolders(treeNode: IoTreeNodeModel, folder: PresentationFoldersConfigurationModel): IoTreeNodeModel {
    const node = treeNode.children.find(p => p.id === folder.ParentFolderPresentationID);
    if (node) {
      return node;
    } else {
      for (const innerNode of treeNode.children) {
        const tmp = this.sortFoldersIntoFolders(innerNode, folder);
        if (tmp) {
          return tmp;
        }
      }
    }
  }

  onChangeClient(e: TdoDropdownChange): void {
    if (!e.isUserInput) {
      return;
    }
    this.selectedClient = e.value;
    this.isLoading = true;
    this.opsService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
      this.locationList = ldata;
      this.selectedLocation = null;

      if (this.locationList.length > 0) {
        this.selectedLocation = this.locationList[0];
        const evt = new TdoDropdownChange();
        evt.value = this.selectedLocation;
        evt.isUserInput = true;
        this.onChangeLoc(evt);
      }
      this.isLoading = false;
    }, err => {
      console.log(err);
      this.isLoading = false;
    });

  }

  private onChangeLoc(e: TdoDropdownChange) {
    if (!e.isUserInput) {
      return;
    }
    this.selectedLocation = e.value;
    this.isLoading = true;
    this.selectedFolder = null;
    this.ReloadPresentationFolders();
/*
    this.presentationService.getPresentationFolders(this.globals.LOCID).subscribe(ddata => {
      console.log('getting folders ', ddata);
      this.folderList = ddata;
      this.selectedFolder = this.folderList[0];
      this.initFolderTree(ddata);
      this.isLoading = false;
    }, err => {
      console.log(err);
      this.isLoading = false;
    });
*/

  }
  private ReloadPresentationFolders() {
    this.presentationService.getPresentationFolders(this.globals.LOCID).subscribe(ddata => {
      console.log('getting folders ', ddata);
      this.folderList = [];
      this.FolderTreeData = [];
      this.folderList = ddata;
      this.selectedFolder = this.folderList[0];
      this.initFolderTree(ddata);
      this.isLoading = false;
    }, err => {
      console.log(err);
      this.isLoading = false;
    });
  }

  isFolderItemSelected(folder: PresentationFoldersConfigurationModel) {

  }

  onFolderChanged(folder: PresentationFoldersConfigurationModel) {

  }

  onDeleteFolder(folder: PresentationFoldersConfigurationModel) {

  }

  addFolder() {
    const folder = new PresentationFoldersConfigurationModel();
    folder.DisplayName = 'Enter Folder Name';
    folder.LOCID = this.selectedLocation.LOCID;
    folder.ParentFolderPresentationID = null;
    //this.folderList.unshift(folder);
    this.selectedFolder = folder;
  }

  onModelChange(selectedFolder: PresentationFoldersConfigurationModel) {

  }

  onAdd($event: any) {
    const folder = new PresentationFoldersConfigurationModel();
    folder.DisplayName = 'Enter Folder Name';
    folder.LOCID = this.selectedLocation.LOCID;
    folder.ParentFolderPresentationID = null;
    this.selectedFolder = folder;

  }

  onSave($event: any) {
    this.isLoading = true;

    this.presentationService.savePresentationFolders(this.selectedFolder).subscribe((res) => {
      if (res) {
        this.snackbar.open('Presentation folder saved.', '', {duration: 5000});
        this.isLoading = false;
        this.ReloadPresentationFolders();
      }
    });
  }

  openFolderSelector($event: MouseEvent) {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';

    // config.height = '600px';
    // config.width = '600px';

    config.data = {
      PickList: 'true',
    };
    this.dialog.open(FolderSelectionDialogComponent, config).afterClosed().subscribe((result) => {
      if (result) {
        this.selectedFolder.DocumnetFolderId = result.id;
      }
    });
/*    const model = new ProcedureSelectionDialogModel();
    model.datasource = this.procedures;
    this.dialogService.openProcedureDialog(model).subscribe((res) => {
      if (res) {
        this.selectedLocation.FormsRepoCaseProcedureId = res.id;
      }
    });*/
  }

  getFolderById(FolderId: string) {
    if (this.libraryFolders) {
      const fold = this.libraryFolders.find(p => p.DocumnetFolderId === FolderId);
      if (fold) {
        return fold.FolderName;
      }
      else {
        if (this.lectureFolders) {
          const lec = this.lectureFolders.find(p => p.DocumnetFolderId === FolderId);
          if (lec) {
            return lec.FolderName;
          }
        }
      }
    }
    else {
      return null;
    }
  }

  onAddChild($event: MouseEvent) {
    const folder = new PresentationFoldersConfigurationModel();
    folder.DisplayName = 'New Child Folder';
    folder.LOCID = this.selectedLocation.LOCID;
    folder.ParentFolderPresentationID = this.selectedFolder.FolderPresentationID;
    folder.DocumnetFolderId = null;
    //this.folderList.unshift(folder);
    this.selectedFolder = folder;
  }

  onFolderTreeItemSelected(item: ITdoTreeItem) {
    item.isExpanded = !item.isExpanded;
    if (this.selectedFolderTreeNode === item) {
      return;
    }
    this.selectedFolderTreeNode = item as IoTreeNodeModel;
    const selected = this.folderList.filter(p => p.FolderPresentationID === this.selectedFolderTreeNode.id);
    this.selectedFolder = selected[0];
  }
  onFolderTreeContext($event: MouseEvent, item: any) {

  }

  isItemSelected(item: ITdoTreeItem): boolean {
    return item === this.selectedFolderTreeNode;
  }

  onDelete($event: MouseEvent) {
    this.isLoading = true;
    this.presentationService.deletePresentationFolder(this.selectedFolder).subscribe((res) => {
      if (res) {
        this.snackbar.open('Presentation folder deleted.', '', {duration: 5000});
        this.isLoading = false;
        this.selectedFolder = null;
        this.ReloadPresentationFolders();
      }
    });
  }
}
